import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as fromAccount from '../reducers/account.reducer'

export const getAccountState = createSelector(
  createFeatureSelector(fromAccount.accountFeatureKey),
  (state: fromAccount.AccountState) => state,
)

export const getAccountStatus = createSelector(getAccountState, (state) => state.status)

export const getTemporaryBlockExpiration = createSelector(getAccountState, (state) => state.temporaryBlockExpiration)
